export default "__VITE_ASSET__DwtVAQWP__"